module.exports = __webpack_public_path__ + "media/assets/svgs/twitter-0f61c06b1bdbee5c716c672683b59d88.svg";